import { Injectable, inject } from '@angular/core';
import { RouterBaseService } from '../../services/router/router-base.service';
import type { HelpArticleResolver } from './help-link.domain';

@Injectable()
export class HelpLinkArticleResolverService implements HelpArticleResolver {
  private readonly routerService = inject<RouterBaseService>(RouterBaseService);

  /**
   * Retrieves help article id from current route state
   *
   * @returns helpId found from current route state
   */
  getHelpArticleId(): string {
    const data = this.routerService.getRouteData() as { helpId: string };
    return data?.helpId ?? '';
  }
}
